import React, { useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../components/ui/popover";
import { Button } from "../../components/ui/button";
import { TrashIcon, Cross1Icon } from "@radix-ui/react-icons";
import { IAppointmentsDataType } from "../../redux/reduxAppointments/appointmentsSlice";
import { toast } from "react-toastify";
import { deleteAppointment } from "../networkCalls";
import { error } from "console";
var _ = require("lodash");

export function ConfirmDeletePopover({
  appointmentDetails,
}: {
  appointmentDetails: IAppointmentsDataType;
}) {
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  function onDelete(appointmentId: string) {
    if (_.isEmpty(appointmentId)) {
      toast.error("There was an error getting appointment. Please try again");
    }
    deleteAppointment(appointmentId)
      .then((deleteStatus) => {
        if (deleteStatus) {
          toast.success("Successfully deleted appointment");
        } else {
          toast.error("Failed to deleet appointment");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("There was an error getting appointment. Please try again");
      });
  }
  return (
    <Popover open={openDelete}>
      <PopoverTrigger asChild>
        <Button
          variant="link"
          size="icon"
          className="absolute right-6 p-2"
          onClick={() => setOpenDelete(true)}
        >
          <TrashIcon color="#E10B00" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-4 bg-white shadow-lg rounded-md w-80 text-center">
        <p className="font-medium">
          Are you sure you want to delete appointment for{" "}
          <span className="font-bold">{appointmentDetails.firstName}</span>
        </p>

        <Button
          variant="outline"
          className="px-4 mx-4"
          onClick={() => {
            onDelete(appointmentDetails.id);
            setOpenDelete(false);
          }}
        >
          <TrashIcon color="#E10B00" />
        </Button>
        <Button
          variant="outline"
          color="green"
          className="px-4 mx-4 "
          onClick={() => setOpenDelete(false)}
        >
          <Cross1Icon color="#54AD56" />
        </Button>
      </PopoverContent>
    </Popover>
  );
}
